"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _eventemitter = _interopRequireDefault(require("eventemitter3"));

var _xhr2Cookies = require("xhr2-cookies");

var _utils = require("@walletconnect/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var XHR = (0, _utils.getFromWindow)("XMLHttpRequest") || _xhr2Cookies.XMLHttpRequest;

var HTTPConnection = /*#__PURE__*/function (_EventEmitter) {
  _inherits(HTTPConnection, _EventEmitter);

  var _super = _createSuper(HTTPConnection);

  function HTTPConnection(url) {
    var _this;

    _classCallCheck(this, HTTPConnection);

    _this = _super.call(this);
    _this.url = url;
    return _this;
  }

  _createClass(HTTPConnection, [{
    key: "formatError",
    value: function formatError(payload, message) {
      var code = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
      return {
        error: {
          message: message,
          code: code
        },
        id: payload.id,
        jsonrpc: payload.jsonrpc
      };
    }
  }, {
    key: "send",
    value: function send(payload, internal) {
      var _this2 = this;

      return new Promise(function (resolve) {
        if (payload.method === "eth_subscribe") {
          var error = _this2.formatError(payload, "Subscriptions are not supported by this HTTP endpoint");

          _this2.emit("error", error);

          return resolve(error);
        }

        var xhr = new XHR();
        var responded = false;

        var res = function res(err, result) {
          if (!responded) {
            xhr.abort();
            responded = true;

            if (internal) {
              internal(err, result);
            } else {
              var id = payload.id,
                  jsonrpc = payload.jsonrpc;
              var response = err ? {
                id: id,
                jsonrpc: jsonrpc,
                error: {
                  message: err.message,
                  code: err.code
                }
              } : {
                id: id,
                jsonrpc: jsonrpc,
                result: result
              };

              _this2.emit("payload", response);

              resolve(response);
            }
          }
        };

        xhr.open("POST", _this2.url, true);
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.timeout = 60 * 1000;
        xhr.onerror = res;
        xhr.ontimeout = res;

        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4) {
            try {
              var response = JSON.parse(xhr.responseText);
              res(response.error, response.result);
            } catch (e) {
              res(e);
            }
          }
        };

        xhr.send(JSON.stringify(payload));
      });
    }
  }]);

  return HTTPConnection;
}(_eventemitter.default);

var _default = HTTPConnection;
exports.default = _default;